module.exports = __webpack_public_path__ + "img/42_21_500_006.4c07e9ef.jpg";